export const processParameters = {
    surfaceFinishings: [
        {
            key: 'surface_dispersion_gloss_varnish',
            label: 'Dispersion Gloss Varnish',
        },
        {
            key: 'surface_dispersion_matt_varnish',
            label: 'Dispersion Matt Varnish',
        },
        {
            key: 'surface_gloss_laminate',
            label: 'Gloss Laminate',
        },
        {
            key: 'surface_matt_laminate',
            label: 'Matt Laminate',
        },
        {
            key: 'surface_none',
            label: 'No Surface Finishing',
        },
        {
            key: 'surface_semi_matt_laminate',
            label: 'Semi-Matt Laminate',
        },
        {
            key: 'surface_uv_matt_varnish',
            label: 'UV Matt Varnish',
        },
        {
            key: 'surface_uv_gloss_varnish',
            label: 'UV Gloss Varnish',
        },
    ],
    screenTypes: [
        {
            label: 'AM',
            rulingUnit: 'lpi',
            key: 'AM',
            configurations: [
                {
                    label: '0°',
                    value: 0,
                },
                {
                    label: '15°',
                    value: 1,
                },
                {
                    label: '45°',
                    value: 2,
                },
                {
                    label: '75°',
                    value: 3,
                },
            ],
        },
        {
            label: 'EM-Gravure',
            rulingUnit: 'lpi',
            key: 'EM_gravure',
            configurations: [
                {
                    label: '70/0',
                    value: 0,
                },
                {
                    label: '70/2',
                    value: 1,
                },
                {
                    label: '70/3',
                    value: 2,
                },
                {
                    label: '70/4',
                    value: 3,
                },
            ],
        },
        {
            label: 'FM',
            rulingUnit: 'μ',
            key: 'FM',
            configurations: null,
        },
    ],
    substrateCategories: [
        {
            key: 'category_cardboard',
            label: 'Cardboard',
            substrateTypes: [
                {
                    key: 'cardboard_coated_glossy',
                    label: 'Coated - glossy',
                    printDirections: null,
                },
                {
                    key: 'cardboard_coated_matte',
                    label: 'Coated - matte',
                    printDirections: null,
                },
                {
                    key: 'cardboard_corrugated_uncoated',
                    label: 'Corrugated',
                    printDirections: null,
                },
            ],
            filmMaterial: null,
        },
        {
            key: 'category_film',
            label: 'Film',
            substrateTypes: [
                {
                    key: 'film_transparent_with_additional_white',
                    label: 'Transparent + Additional white layer',
                    printDirections: [
                        {
                            label: 'Front',
                            value: false,
                        },
                        {
                            label: 'Reverse',
                            value: true,
                        },
                    ],
                },
                {
                    key: 'film_white',
                    label: 'White',
                    printDirections: null,
                },
                {
                    key: 'film_metallic_white_undercoat',
                    label: 'Metallic + White undercoat',
                    printDirections: null,
                },
            ],
            filmMaterial: [
                { key: 'OPP/CPP', label: 'OPP/CPP' },
                { key: 'PET', label: 'PET' },
                { key: 'PVC', label: 'PVC' },
                { key: 'LDPE', label: 'LDPE' },
            ],
        },
        {
            key: 'category_paper',
            label: 'Paper',
            substrateTypes: [
                {
                    key: 'paper_coated_matte',
                    label: 'Coated - matte',
                    printDirections: null,
                },
                {
                    key: 'paper_coated_glossy',
                    label: 'Coated - glossy',
                    printDirections: null,
                },
                {
                    key: 'paper_super_calendered',
                    label: 'Super Calendered',
                    printDirections: null,
                },
                {
                    key: 'paper_uncoated',
                    label: 'Uncoated',
                    printDirections: null,
                },
            ],
            filmMaterial: null,
        },

    ],
    printingProcesses: [
        {
            key: 'digital_toner',
            label: 'Digital Toner',
        },
        {
            key: 'digital_inkjet',
            label: 'Digital Inkjet',
        },
        {
            key: 'flexo_conventional',
            label: 'Flexo',
        },
        {
            key: 'gravure',
            label: 'Gravure',
        },
        {
            key: 'offset',
            label: 'Offset / Litho',
        },
    ],
};
